// Fragment "stripeTransactions" — StripeTransactions.jsx (paiements Stripe plateforme).
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    "stx.title": "Paiements Stripe (plateforme)",
    "stx.desc": "Achats des clients encaissés sur le compte Stripe de la plateforme — cartes cadeaux, programmes, produits et factures.",
    "stx.empty": "Aucun paiement Stripe pour le moment.",
    "stx.refund": "Rembourser",
    "stx.refunded": "Remboursé",
    "stx.refundTitle": "Rembourser ce paiement",
    "stx.refundCharged": "Montant encaissé : {amount}",
    "stx.refundAlready": "Déjà remboursé : {amount}",
    "stx.refundRemaining": "Remboursable : {amount}",
    "stx.refundAmountLabel": "Montant à rembourser ({currency})",
    "stx.refundAmountInvalid": "Saisissez un montant, avec deux décimales au maximum.",
    "stx.refundAmountTooHigh": "Le montant dépasse le solde remboursable ({amount}).",
    "stx.refundGiftcardOnly": "Une carte-cadeau ne peut pas être remboursée partiellement : son solde est au porteur et peut déjà avoir été dépensé. Ce remboursement portera sur la totalité.",
    "stx.refundSplitTenderOnly": "Cet achat a été payé en partie avec une carte-cadeau et ne peut pas être remboursé partiellement. Ce remboursement portera sur la totalité.",
    "stx.refundCancel": "Annuler",
    "stx.refundConfirm": "Rembourser",
    "stx.successPartial": "{amount} remboursé",
    "stx.retainedUnknown": "Partiellement remboursé — la part que vous conservez sur cette vente est arrêtée dans le grand livre, pas indiquée sur cette ligne.",
    "stx.success": "Remboursement effectué",
    "stx.error": "Erreur lors du remboursement",
    "stx.colKind": "Type",
    "stx.colEmail": "Client",
    "stx.colAmount": "Montant",
    "stx.colDate": "Date",
    "stx.colStatus": "Statut",
    "stx.kind.booking": "Rendez-vous",
    "stx.kind.course": "Cours",
    "stx.kind.pathway": "Parcours",
    "stx.kind.product": "Produit",
    "stx.kind.program": "Programme",
    "stx.kind.invoice": "Facture",
    "stx.kind.telehealth": "Téléconsultation",
    "stx.kind.giftcard": "Carte-cadeau",
    "stx.status.paid": "Payé",
    "stx.status.unpaid": "Impayé",
    "stx.status.initiated": "Initié",
    "stx.status.completed": "Terminé",
    "stx.status.partial": "Partiellement remboursé",
    "stx.filter.all": "Tous",
    "stx.filter.paid": "Payé",
    "stx.filter.unpaid": "Impayé",
    "stx.filter.refunded": "Remboursé",
    "stx.emptyFiltered": "Aucun paiement ne correspond à ce filtre.",
    "stx.searchLabel": "Rechercher un client",
    "stx.searchPlaceholder": "Adresse e-mail du client",
    "stx.kindAny": "Tous les types",
    "stx.dateFrom": "Du",
    "stx.dateTo": "Au",
    "stx.count": "{from}–{to} sur {total} paiements",
    "stx.countNone": "Aucun paiement",
    "stx.pagePrev": "Précédent",
    "stx.pageNext": "Suivant",
    "stx.pageOf": "Page {page} sur {pages}",
    "stx.refundedFull": "−{amount} remboursé",
    "stx.refundedPartial": "−{amount} remboursé partiellement",
    "stx.refundOwed": "Remboursement dû −{amount}",
    "stx.totalsNote": "Les paiements remboursés restent dans la liste ci-dessus avec la mention « Remboursé » — ils cessent simplement de compter dans ces totaux. Les filtres Payé / Impayé / Remboursé ne modifient jamais ces montants ; une recherche, un type ou une période, oui.",
  },
  en: {
    "stx.title": "Stripe payments (platform)",
    "stx.desc": "Customer purchases collected on the platform Stripe account — gift cards, programs, products and invoices.",
    "stx.empty": "No Stripe payments yet.",
    "stx.refund": "Refund",
    "stx.refunded": "Refunded",
    "stx.refundTitle": "Refund this payment",
    "stx.refundCharged": "Charged: {amount}",
    "stx.refundAlready": "Already refunded: {amount}",
    "stx.refundRemaining": "Refundable: {amount}",
    "stx.refundAmountLabel": "Amount to refund ({currency})",
    "stx.refundAmountInvalid": "Enter an amount, with at most two decimals.",
    "stx.refundAmountTooHigh": "That is more than the refundable balance ({amount}).",
    "stx.refundGiftcardOnly": "A gift card cannot be partially refunded: its balance is bearer-held and may already have been spent. This will refund it in full.",
    "stx.refundSplitTenderOnly": "This purchase was part-paid with a gift card and cannot be partially refunded. This will refund it in full.",
    "stx.refundCancel": "Cancel",
    "stx.refundConfirm": "Refund",
    "stx.successPartial": "{amount} refunded",
    "stx.retainedUnknown": "Partially refunded — what you kept of this sale is settled in the ledger, not stated on this row.",
    "stx.success": "Refund completed",
    "stx.error": "Error while refunding",
    "stx.colKind": "Type",
    "stx.colEmail": "Customer",
    "stx.colAmount": "Amount",
    "stx.colDate": "Date",
    "stx.colStatus": "Status",
    "stx.kind.booking": "Appointment",
    "stx.kind.course": "Course",
    "stx.kind.pathway": "Pathway",
    "stx.kind.product": "Product",
    "stx.kind.program": "Programme",
    "stx.kind.invoice": "Invoice",
    "stx.kind.telehealth": "Telehealth",
    "stx.kind.giftcard": "Gift card",
    "stx.status.paid": "Paid",
    "stx.status.unpaid": "Unpaid",
    "stx.status.initiated": "Initiated",
    "stx.status.completed": "Completed",
    "stx.status.partial": "Partially refunded",
    "stx.filter.all": "All",
    "stx.filter.paid": "Paid",
    "stx.filter.unpaid": "Unpaid",
    "stx.filter.refunded": "Refunded",
    "stx.emptyFiltered": "No payments match this filter.",
    "stx.searchLabel": "Search for a client",
    "stx.searchPlaceholder": "Client email address",
    "stx.kindAny": "All types",
    "stx.dateFrom": "From",
    "stx.dateTo": "To",
    "stx.count": "{from}–{to} of {total} payments",
    "stx.countNone": "No payments",
    "stx.pagePrev": "Previous",
    "stx.pageNext": "Next",
    "stx.pageOf": "Page {page} of {pages}",
    "stx.refundedFull": "−{amount} refunded",
    "stx.refundedPartial": "−{amount} partially refunded",
    "stx.refundOwed": "Refund owed −{amount}",
    "stx.totalsNote": "Refunded payments stay in the list above with a Refunded badge — they simply stop counting toward these totals. The Paid / Unpaid / Refunded chips never move these figures; a search, a type or a date range does.",
  },
  es: {
    "stx.title": "Pagos Stripe (plataforma)",
    "stx.desc": "Compras de clientes cobradas en la cuenta Stripe de la plataforma — tarjetas regalo, programas, productos y facturas.",
    "stx.empty": "Aún no hay pagos Stripe.",
    "stx.refund": "Reembolsar",
    "stx.refunded": "Reembolsado",
    "stx.refundTitle": "Reembolsar este pago",
    "stx.refundCharged": "Importe cobrado: {amount}",
    "stx.refundAlready": "Ya reembolsado: {amount}",
    "stx.refundRemaining": "Reembolsable: {amount}",
    "stx.refundAmountLabel": "Importe a reembolsar ({currency})",
    "stx.refundAmountInvalid": "Introduzca un importe, con dos decimales como máximo.",
    "stx.refundAmountTooHigh": "Supera el saldo reembolsable ({amount}).",
    "stx.refundGiftcardOnly": "Una tarjeta regalo no puede reembolsarse parcialmente: su saldo es al portador y puede haberse gastado ya. Este reembolso será por el total.",
    "stx.refundSplitTenderOnly": "Esta compra se pagó en parte con una tarjeta regalo y no puede reembolsarse parcialmente. Este reembolso será por el total.",
    "stx.refundCancel": "Cancelar",
    "stx.refundConfirm": "Reembolsar",
    "stx.successPartial": "{amount} reembolsado",
    "stx.retainedUnknown": "Reembolsado parcialmente — lo que conserva de esta venta se liquida en el libro mayor, no se indica en esta fila.",
    "stx.success": "Reembolso realizado",
    "stx.error": "Error al reembolsar",
    "stx.colKind": "Tipo",
    "stx.colEmail": "Cliente",
    "stx.colAmount": "Importe",
    "stx.colDate": "Fecha",
    "stx.colStatus": "Estado",
    "stx.kind.booking": "Cita",
    "stx.kind.course": "Curso",
    "stx.kind.pathway": "Itinerario",
    "stx.kind.product": "Producto",
    "stx.kind.program": "Programa",
    "stx.kind.invoice": "Factura",
    "stx.kind.telehealth": "Teleconsulta",
    "stx.kind.giftcard": "Tarjeta regalo",
    "stx.status.paid": "Pagado",
    "stx.status.unpaid": "Sin pagar",
    "stx.status.initiated": "Iniciado",
    "stx.status.completed": "Completado",
    "stx.status.partial": "Reembolsado parcialmente",
    "stx.filter.all": "Todos",
    "stx.filter.paid": "Pagado",
    "stx.filter.unpaid": "Sin pagar",
    "stx.filter.refunded": "Reembolsado",
    "stx.emptyFiltered": "Ningún pago coincide con este filtro.",
    "stx.searchLabel": "Buscar un cliente",
    "stx.searchPlaceholder": "Correo electrónico del cliente",
    "stx.kindAny": "Todos los tipos",
    "stx.dateFrom": "Desde",
    "stx.dateTo": "Hasta",
    "stx.count": "{from}–{to} de {total} pagos",
    "stx.countNone": "Ningún pago",
    "stx.pagePrev": "Anterior",
    "stx.pageNext": "Siguiente",
    "stx.pageOf": "Página {page} de {pages}",
    "stx.refundedFull": "−{amount} reembolsado",
    "stx.refundedPartial": "−{amount} reembolsado parcialmente",
    "stx.refundOwed": "Reembolso pendiente −{amount}",
    "stx.totalsNote": "Los pagos reembolsados siguen en la lista de arriba con la etiqueta «Reembolsado»: solo dejan de contar en estos totales. Los filtros Pagado / Sin pagar / Reembolsado nunca cambian estas cifras; una búsqueda, un tipo o un periodo sí.",
  },
};
